/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Wetalkie extends CacheEnabledApiClient {
  constructor() {
    super('wetalkie', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'wetalkie';
  }

  async getTabulations(domain, username, password) {
    try {
      const url = `${this.url}/tabulations?domain=${domain}&username=${username}&password=${password}`;

      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async getTabulationsByInbox(identifier) {
    try {
      const url = `${this.url}/tabulations?identifier=${identifier}`;

      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async getUsers(domain, username, password) {
    try {
      const url = `${this.url}/users?domain=${domain}&username=${username}&password=${password}`;

      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async getUsersByInbox(identifier) {
    try {
      const url = `${this.url}/users?identifier=${identifier}`;

      const response = await axios.get(url);
      return response.data ?? [];
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async fetchConversations(identifier, { beginDate, endDate, force } = {}) {
    const url = `${this.url}/fetch_conversations`;
    const response = await axios.post(url, {
      identifier,
      begin_date: beginDate,
      end_date: endDate,
      force,
    });
    return response.data;
  }
}

export default new Wetalkie();
